// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"248":"c9d65b967658896d","947":"42527854e1001cb7"}[chunkId] + ".css";
};